import React, { useEffect, useContext } from "react";
import $ from "jquery";
import "here-js-api/scripts/mapsjs-core";
import "here-js-api/scripts/mapsjs-service";
import "here-js-api/scripts/mapsjs-ui";
import "here-js-api/scripts/mapsjs-mapevents";
import "here-js-api/scripts/mapsjs-clustering";
import { Here } from "./here.class.js";
import H from "@here/maps-api-for-javascript";
import {DashboardContext} from "../../../../../contexts/Dashboard/DashboardContext"

function panTheMap(map) {
  var incX = 100,
    // incY = 2,
    x = 100,
    y = 100;

  var viewPort = map.getViewPort(),
    pan = function () {
      x = x + incX;
      viewPort.interaction(x, y);
    };

  viewPort.startInteraction(
    H.map.render.RenderEngine.InteractionModifiers.COORD,
    0,
    0
  );

  setTimeout(pan, 1000);
  setTimeout(pan, 1000);
  setTimeout(pan, 1000);
}

function createMaps(routes, sizes) {
  // const {setFontSize } = useContext(DashboardContext)
  // if (sizes.width < 345) {
  //   setFontSize({ id="map-routes", width: sizes.width });
  // }
  var div_mapa = document.getElementById("map-routes");

  div_mapa.style.height = `${sizes.height-70}px`
  div_mapa.style.width = `${sizes.width}px`

  let mapa = document.getElementById("mapa");

  mapa.style.borderRadius = "15px";

  if ($("#map-routes").length > 0) {
    let map_routes = new Here();
    map_routes.createMap("map-routes");
    map_routes.createControllers(false);

    let base = [],
      transito = [],
      pendente = [];

    routes.routes.forEach((route) => {
      switch (true) {
        case [6, 10].some((i) => [route.status_route_id].includes(i)):
          base.push({
            id: route.id,
            lat: route.position.latitude,
            lng: route.position.longitude,
          });
          break;
        case [2, 3, 4, 5, 7, 8, 9].some((i) =>
          [route.status_route_id].includes(i)
        ):
          transito.push({
            id: route.id,
            lat: route.position.latitude,
            lng: route.position.longitude,
          });
          break;
        case [0, 1].some((i) => [route.status_route_id].includes(i)):
          pendente.push({
            id: route.id,
            lat: route.position.latitude,
            lng: route.position.longitude,
          });
          break;

        default:
          break;
      }
    });
    
    map_routes.startClustering(base, "base");

    map_routes.startClustering(transito, "in_transit");

    map_routes.startClustering(pendente, "pending");

    map_routes.centerMap(map_routes.coords);

    panTheMap(map_routes.map);

    $(".shakeable").click(function () {
      map_routes.shakePin($(this).find("input").val());
    });

    // Redimensionamento do mapa quando o tamanho da tela é alterado
    window.addEventListener("resize", { passive: true }, function () {
      map_routes.map.getViewPort().resize();
    });
  }
}

export const Map = ({routes}) => {
  const { getSizesComponent} = useContext(DashboardContext)

  useEffect(() => {
    const sizes = getSizesComponent({id:"map-routes"})
    createMaps(routes,sizes);
  },[])

  return <></>;
};
